export const GENDER_OPTIONS = [
  'Agender',
  'Female',
  'Genderfluid',
  'Genderqueer',
  'Male',
  'Non-binary',
  'Pangender',
  'Transgender',
  'Other'
] as const;

export const SEXUALITY_OPTIONS = [
  'Androgynsexual',
  'Aromantic',
  'Asexual',
  'Bi-curious',
  'Bisexual',
  'Demisexual',
  'Gay',
  'Heteroflexible',
  'Homoseksuel',
  'Homoflexible',
  'Lesbian',
  'Pansexual',
  'Queer',
  'Questioning',
  'Sapiosexual',
  'Straight',
  'Other'
] as const;

export const LOOKING_FOR_OPTIONS = [
  'Long-term relationship',
  'Short-term dating',
  'Exploring',
  'Friends',
  'Community',
  'Events'
] as const;

export const PRONOUN_OPTIONS = [
  'He/Him',
  'He/They',
  'She/Her',
  'She/They',
  'They/Them',
  'Any',
  'Ask me'
] as const;

export const PROFILE_TYPE_OPTIONS = [
  'Standard',
  'Community',
  'Event'
] as const;
